/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityLookalikesSslIssuer
 */
export interface ControlEntityLookalikesSslIssuer {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesSslIssuer
     */
    country_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesSslIssuer
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesSslIssuer
     */
    common_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesSslIssuer
     */
    distinguished_name?: string;
}

/**
 * Check if a given object implements the ControlEntityLookalikesSslIssuer interface.
 */
export function instanceOfControlEntityLookalikesSslIssuer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityLookalikesSslIssuerFromJSON(json: any): ControlEntityLookalikesSslIssuer {
    return ControlEntityLookalikesSslIssuerFromJSONTyped(json, false);
}

export function ControlEntityLookalikesSslIssuerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityLookalikesSslIssuer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'country_name': !exists(json, 'country_name') ? undefined : json['country_name'],
        'organization_name': !exists(json, 'organization_name') ? undefined : json['organization_name'],
        'common_name': !exists(json, 'common_name') ? undefined : json['common_name'],
        'distinguished_name': !exists(json, 'distinguished_name') ? undefined : json['distinguished_name'],
    };
}

export function ControlEntityLookalikesSslIssuerToJSON(value?: ControlEntityLookalikesSslIssuer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'country_name': value.country_name,
        'organization_name': value.organization_name,
        'common_name': value.common_name,
        'distinguished_name': value.distinguished_name,
    };
}

